﻿$.fn.dxCtrlGridCognossIa = function custom_dxCtrlGridCognossIa(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridcognossia dx-ctrl");
        this.createInstance(new cdxCtrlGridCognossIa(this, option));
    }
    return this;
}

window.cdxCtrlGridCognossIa = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "gridcognossia"

    var dxGrid = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid({
            bddCtrl: option.bddCtrl,
            noDataText: "Aucun cognoss",
            typeData: "cognoss_ia",
            context_grid: option.context_grid,
            itemsToolbar: mGetLstButtonToolBar(),
            onDisplayButtonLigne: mGetLstButtonLigne,
            lstTypeGrille: ["Détails"],
            fields: mGetLstField(),
            allowCarto: false,
            allowFilter: true,
            allowLucene: true,
            allowCheck: true,
            getItemTemplateHeight: function () { return 80 },
            getAlignItem: function () { return "right" },
            itemTemplateGrille: function (container, dataTemplate, type) {
                $("<div style='margin:5px;'/>").appendTo(container).dxTagBox({
                    dataSource: parametre.lst_appli_maitre,
                    value: dataTemplate.lst_code_appli.split(","),
                    displayExpr: "code_appli",
                    valueExpr: "code_appli",
                    onValueChanged: function (e) {
                        var result = ""
                        e.value.forEach(function (codeAppli) {
                            result += ((result.length > 0) ? "," : "") + codeAppli
                        })
                        option.bddCtrl.mAjaxCall({ command: "saveqria", id: dataTemplate.id_key, champ: "lst_code_appli", value: result })
                    }
                })
                $("<div style='margin:5px;'/>").appendTo(container).dxTextBox({
                    value: dataTemplate.question,
                    onValueChanged: function (e) {
                        option.bddCtrl.mAjaxCall({ command: "saveqria", id: dataTemplate.id_key, champ: "question", value: e.value })
                    }
                })
                $("<div style='margin:5px;'/>").appendTo(container).dxTextArea({
                    value: dataTemplate.reponse,
                    height: 150,
                    onValueChanged: function (e) {
                        option.bddCtrl.mAjaxCall({ command: "saveqria", id: dataTemplate.id_key, champ: "reponse", value: e.value })
                    }
                })
            },
            itemTemplateGrillePlus: function (container, dataTemplate, type) {
                var $S = $("<span style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataTemplate.dcr.toDateIlya(true) + "</span>").appendTo(container)
                $S.attr("title", "Créé le " + dataTemplate.dcr.toFrenchDateTime())
            },
            itemTemplateIco: function (container, dataTemplate) {
                $("<i class='fafa fafa-mia'></i>").appendTo(container)
            },
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
            },
        }).dxCtrlVirtualGrid("instance")
    }

    function mGetLstField() {
        var lst = []
        lst = lst.concat([{
            name: "grp_dcr_ilya",
            dataField: "grp_dcr_ilya",
            caption: "Date création",
            icon: "fas fa-clock-rotate-left",
            allowFilter: false,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            visible: true,
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            groupIndex: 0,
            sortOrder: "desc",
            calculateGroupValue: function (rowData) {
                return rowData.grp_dcr_ilya
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Référence: " + options.displayValue.getGroupDateLibelle() + " (" + tot + ")")
            },
            calculateCellValue: function (rowData) {
                return rowData.grp_dcr_ilya
            },
            calculateSortValue: function (rowData) {
                return rowData.grp_dcr_ilya
            },
            filterLinkGrp: "dcr_tri"
        }, {
            name: "dcr_tri",
            dataField: "dcr_tri",
            allowGrid: true,
            visible: false
            }])
        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []

        items.push({
            location: 'before',
            template: function (itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fafa fafa-mia",
                    icon2: "fas fa-certificate",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    txtTooltip: "Nouvel QR",
                    onClick: function (e) {
                        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                            fullscreen: false,
                            height: "auto",
                            width: 700,
                            title:"Q/R IA",
                            contentTemplate: function (contentElement) {
                                var dxTagB = $("<div style='margin:5px;'/>").appendTo(contentElement).dxTagBox({
                                    label: "Code appli générale",
                                    labelMode: 'floating',
                                    dataSource: parametre.lst_appli_maitre,
                                    value: [parametre.lst_appli_all.filter(function (o) { return o.code_appli==parametre.code_appli })[0].code_appli_general],
                                    displayExpr: "code_appli",
                                    valueExpr: "code_appli",
                                    onValueChanged: function (e) {
                                    }
                                }).dxTagBox("instance")
                                var dxTxtQ = $("<div style='margin:5px;'/>").appendTo(contentElement).dxTextBox({
                                    label: "Question",
                                    labelMode: 'floating',
                                    value: "",
                                    onValueChanged: function (e) {
                                    }
                                }).dxTextBox("instance")
                                var dxTxR = $("<div style='margin:5px;'/>").appendTo(contentElement).dxTextArea({
                                    label: "Réponse",
                                    labelMode: 'floating',
                                    value: "",
                                    height:150,
                                    onValueChanged: function (e) {
                                    }
                                }).dxTextArea("instance")
                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                    text: "ok",
                                    onClick: function (e) {
                                        var result = ""
                                        dxTagB.option("value").forEach(function (codeAppli) {
                                            result += ((result.length > 0) ? "," : "") + codeAppli
                                        })
                                        option.bddCtrl.mAjaxCall({
                                            command: "saveqria",
                                            "lst_code_appli": result,
                                            "question": dxTxtQ.option("value"),
                                            "reponse": dxTxR.option("value")
                                        }, function (data) { })
                                        popup.hide()
                                        dxGrid.mReloadData()
                                    }
                                })
                            }
                        }).dxCtrlPopupBase("instance")
                        popup.show()
                    }
                }).dxCtrlButton("instance")
            }
        })

        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {
        var items = []

        items.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            options: {
                icon: "fas fa-xmark",
                elementAttr: { class: "dx-button-grille-ligne" },
                focusStateEnabled: false,
                text: "Supprimer",
                hint: "Supprimer",
                onClick(e) {
                    e.event.stopPropagation();
                    option.bddCtrl.mAjaxCall({ command: "delqria", id: dataTemplate.id_key })
                    dxGrid.mRemoveRow(dataGrid)
                }
            },
        })

        toolbar.option("items", items)
    }

    this.element = function () { return container }

    mConstruit();
}